import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { CreatorPageComponent } from './components/creator-page/creator-page.component';
import { CreatorPageResolver } from './resolvers/creator-page.resolver';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent
  },
  {
    path: 'me',
    loadChildren: './modules/user/user.module#UserModule'
  },
  {
    path: ':page',
    pathMatch: 'full',
    component: CreatorPageComponent,
    resolve: {
      pageData: CreatorPageResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
